import { compose } from 'lodash/fp'
import PasswordResetToken from './PasswordResetToken'
import withReduxForm from './withReduxForm'
import withLoadLanguage from './withLoadLanguage'
import withState from './withState'

export default compose(
  withReduxForm,
  withState,
  withLoadLanguage,
)(PasswordResetToken)
